import React from 'react';
import { BadgeCheckIcon, CodeIcon, StarIcon, MessageSquareIcon, AwardIcon, TrophyIcon, ExternalLinkIcon, NewspaperIcon } from 'lucide-react';
interface Credential {
  icon: React.ReactNode;
  title: string;
  proof: string;
  accent: string;
  href?: string;
}
const CREDENTIALS: Credential[] = [{
  icon: <BadgeCheckIcon className="w-6 h-6 text-emerald-400" data-id="element-43" />,
  title: 'Shopify Partner',
  proof: 'Official Shopify Partner agency',
  accent: 'emerald',
  href: 'https://www.shopify.com/partners/directory/partner/designflowdigitals'
}, {
  icon: <CodeIcon className="w-6 h-6 text-emerald-400" data-id="element-44" />,
  title: 'Shopify App Developer',
  proof: 'Published on the Shopify App Store',
  accent: 'emerald',
  href: 'https://apps.shopify.com/partners/designflowdigitals'
}, {
  icon: <TrophyIcon className="w-6 h-6 text-[#D4AF37]" data-id="element-45" />,
  title: 'Top Rated Fiverr Seller',
  proof: 'Top 1% of Shopify sellers',
  accent: 'gold',
  href: 'https://fiverr.com/webpankaj'
}, {
  icon: <MessageSquareIcon className="w-6 h-6 text-[#D4AF37]" data-id="element-46" />,
  title: '700+ Client Reviews',
  proof: 'Consistent 5-star rated delivery',
  accent: 'gold'
}, {
  icon: <AwardIcon className="w-6 h-6 text-emerald-400" data-id="element-47" />,
  title: 'Featured by Omnisend',
  proof: 'Recognized top Shopify expert',
  accent: 'emerald',
  href: 'https://www.omnisend.com/blog/shopify-experts/'
}, {
  icon: <StarIcon className="w-6 h-6 text-[#D4AF37]" data-id="element-48" />,
  title: 'Featured by EComposer',
  proof: 'Listed best Shopify web designer',
  accent: 'gold',
  href: 'https://ecomposer.io/blogs/ecommerce/best-shopify-web-designers'
}, {
  icon: <NewspaperIcon className="w-6 h-6 text-emerald-400" data-id="element-49" />,
  title: 'Featured by Stack Influence',
  proof: 'Named a Top 10 Shopify Expert',
  accent: 'emerald',
  href: 'https://stackinfluence.com/blog/top-10-shopify-experts'
}];
export function AuthoritySection() {
  // Duplicate for seamless infinite scroll
  const marqueeCredentials = [...CREDENTIALS, ...CREDENTIALS];
  return <section className="section-padding bg-black relative border-y border-white/5 overflow-hidden" data-id="element-50">
      <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-10 mix-blend-overlay pointer-events-none" data-id="element-51" />

      <div className="text-center max-w-3xl mx-auto mb-14 relative z-10" data-id="element-52">
        <p className="text-sm font-bold text-[#D4AF37] uppercase tracking-widest mb-4" data-id="element-53">
          Trusted &amp; Recognized
        </p>
        <h2 className="text-3xl md:text-5xl font-bold mb-5" data-id="element-54">
          Authority You Can Verify
        </h2>
        <p className="text-lg text-gray-400" data-id="element-55">
          Credentials and recognition that prove we&apos;re Shopify specialists,
          not generic web designers.
        </p>
      </div>

      {/* Marquee Container */}
      <div className="relative w-full overflow-hidden flex group/marquee z-10" data-id="element-56">
        {/* Gradient Masks for smooth fade at edges */}
        <div className="absolute left-0 top-0 bottom-0 w-24 md:w-40 bg-gradient-to-r from-black to-transparent z-20 pointer-events-none" data-id="element-57" />
        <div className="absolute right-0 top-0 bottom-0 w-24 md:w-40 bg-gradient-to-l from-black to-transparent z-20 pointer-events-none" data-id="element-58" />

        {/* Scrolling Track */}
        <div className="flex whitespace-nowrap animate-marquee items-stretch group-hover/marquee:[animation-play-state:paused]" data-id="element-59">
          {marqueeCredentials.map((cred, i) => {
          const cardClass = `group glass-card p-6 flex items-center gap-5 transition-all duration-300 w-[20rem] shrink-0 ${cred.accent === 'emerald' ? 'hover:border-emerald-500/30' : 'hover:border-[#D4AF37]/30'}`;
          const inner = <>
                <div className={`w-14 h-14 shrink-0 rounded-2xl flex items-center justify-center border transition-colors ${cred.accent === 'emerald' ? 'bg-emerald-500/10 border-emerald-500/20 group-hover:bg-emerald-500/20' : 'bg-[#D4AF37]/10 border-[#D4AF37]/20 group-hover:bg-[#D4AF37]/20'}`} data-id="element-60">
                  {cred.icon}
                </div>
                <div className="flex-1 whitespace-normal" data-id="element-61">
                  <h3 className="text-lg font-bold text-white leading-tight mb-1 flex items-center gap-1.5" data-id="element-62">
                    {cred.title}
                    {cred.href && <ExternalLinkIcon className="w-3.5 h-3.5 text-gray-500 group-hover:text-white transition-colors" data-id="element-63" />}
                  </h3>
                  <p className="text-sm text-gray-400 leading-snug" data-id="element-64">
                    {cred.proof}
                  </p>
                </div>
              </>;
          return cred.href ? <a key={`${cred.title}-${i}`} href={cred.href} target="_blank" rel="noopener noreferrer" className={`${cardClass} mx-3`} data-id="element-65">
                {inner}
              </a> : <div key={`${cred.title}-${i}`} className={`${cardClass} mx-3`} data-id="element-66">
                {inner}
              </div>;
        })}
        </div>
      </div>
    </section>;
}